import React, { useContext, useRef, useState } from 'react';
import { TeApiContext, useSelector } from '@ecommerce/nest-ssr/common';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownMenu from 'layouts/header/search/dropdown-menu/dropdown-menu';
import Button from 'atomic/button';
import SearchOptionInterface from 'layouts/header/search/search-option.interface';
import Autosuggest from 'layouts/header/search/components/autosuggest';

import './search.scss';
import Icon from 'atomic/icon';

const Search: React.FC = () => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const allCategorysOption: SearchOptionInterface = { id: '', name: 'Wszystkie kategorie' };

    const { options = [], selected, query } = useSelector(
        (state: { search: { options: SearchOptionInterface[]; selected: SearchOptionInterface; query: string; }; }) => state.search || {}
    );
    const items = [allCategorysOption, ...options];

    const [option, setOption] = useState(selected
        ? {
            id: selected.id,
            name: selected.name
        }
        : allCategorysOption);

    const [selectedValue, setSelectedValue] = useState<{ id: string; name: string; }>(selected || allCategorysOption);

    const onSelect = (event: any): void => {
        const item = JSON.parse(event.target.dataset.item);

        setOption(item);
        setSelectedValue(item);

        if (item.id === '') {
            setSelectedValue(allCategorysOption);
        }
    };

    const dropdownToggle = (): void => setDropdownOpen(!dropdownOpen);
    const [searchValue, setSearchValue] = useState(query || '');
    const formRef = useRef<any>(null);

    const onChange = (event: any, { newValue }: any): void => setSearchValue(newValue);

    const onSubmit = (): void => formRef.current.submit();

    const handleSubmit = (event: React.FormEvent): void => {
        if (searchValue.length === 0) {
            event.preventDefault();
        }
    };

    return (
        <div className={`search-content${api.getDevice() === 'desktop' ? '' : ' search-content--mobile'}`}>
            <form className="search-content__form" action="/szukaj" method="get"
                ref={formRef} onSubmit={handleSubmit}
            >
                <div className="search-content__form__group">
                    <Autosuggest searchValue={searchValue} selectedValue={selectedValue} onSubmit={onSubmit}
                        onChange={onChange}
                    />
                    <div className="search-content__form__group__categories">
                        <Dropdown className="search-content__form__group__categories__dropdown" onClick={dropdownToggle}
                            alignRight={true}
                        >
                            <Dropdown.Toggle variant="success">
                                {option.name}
                            </Dropdown.Toggle>
                            <DropdownMenu options={items} onSelect={onSelect} value={option.name}/>
                        </Dropdown>
                    </div>
                    <Button className="search-content__form__group__submit" type="submit" color="yellow"
                        uppercase={true} title="Wyszukaj" aria-label="Wyszukaj"
                    >
                        <Icon name="search" color="secondary" size={18}/>
                    </Button>
                </div>
                {selectedValue?.id !== '' && (
                    <input id="search-context-input" type="hidden" value={selectedValue.id}
                        name="categoryId"
                    />
                )}
            </form>
        </div>
    );
};

export default Search;
